import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BookButton } from "@/components/GoldButton";
import { AskChittiButton } from "@/components/AskChittiButton";

export function StickyCta() {
  const [past, setPast] = useState(false);
  const [atEnd, setAtEnd] = useState(false);

  useEffect(() => {
    const onScroll = () => setPast(window.scrollY > window.innerHeight * 0.75);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    const el = document.getElementById("final-cta");
    const obs = el
      ? new IntersectionObserver(([e]) => setAtEnd(e.isIntersecting), { threshold: 0.12 })
      : null;
    if (obs && el) obs.observe(el);
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (obs) obs.disconnect();
    };
  }, []);

  const show = past && !atEnd;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 96 }}
          animate={{ y: 0 }}
          exit={{ y: 96 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          data-testid="sticky-cta-bar"
          className="fixed inset-x-0 bottom-0 z-50 border-t border-[#D4AF37]/40 bg-[#0E0C0A]/95 p-3 shadow-[0_-8px_30px_rgba(0,0,0,0.8)] backdrop-blur-xl md:hidden"
        >
          <div className="flex items-center gap-2">
            <BookButton
              location="sticky"
              testId="sticky-book-tickets-btn"
              label="Tickets Are Live"
              className="flex-[1.6]"
            />
            <AskChittiButton
              location="sticky_mobile"
              label="Ask Chitti"
              testId="sticky-ask-chitti-btn"
              className="flex-1"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
